module.exports = __webpack_public_path__ + "img/youtube.86e7bcc5.png";